<div class="grid-manager-container">
    <span style="font-weight: 700;margin: 10px 0;">GRID GENERATION MANAGER</span>

    <mat-form-field *ngIf="!data?.editPoint" appearance="outline">
        <mat-label>Unit of Measurement</mat-label>
        <mat-select [(ngModel)]="unitOfMeasurement" (ngModelChange)="changeMeasurement($event)">
            <mat-option value="Hectares">Hectares</mat-option>
            <mat-option value="Meters">Meters</mat-option>
        </mat-select>
    </mat-form-field>

     <mat-form-field *ngIf="!data?.editPoint" appearance="outline">
        <mat-label>Grid Spacing {{unitOfMeasurement === 'Hectares' ? '(HA)' : '(Meters)'}}</mat-label>
        <input min="{{unitOfMeasurement === 'Hectares' ? 0.1 : 10}}" matInput type="number" placeholder="Grid Spacing" [(ngModel)]="gridSpacing">
        @if (true) {
            <mat-error>{{'Cannot be less than ' + (unitOfMeasurement === 'Hectares' ? 0.1 : 10)}}</mat-error>
        }
    </mat-form-field>

    <mat-form-field *ngIf="!data?.editPoint" appearance="outline">
        <mat-label>Rotation</mat-label>
        <input matInput type="number" placeholder="(0-360°)" [(ngModel)]="gridRotation" min="0" max="360">
        <mat-error *ngIf="isRotationInvalid">Rotation: 0-360°</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Point Names</mat-label>
        <input matInput type="text" placeholder="Point Name" [(ngModel)]="pointName">
    </mat-form-field>

    <p><mat-slide-toggle *ngIf="!data?.editPoint" [(ngModel)]="isSequential">Sequential</mat-slide-toggle></p>

    <div class="back-btn-dialog-container">
        <button class="cancel-back-dialog-btn" mat-flat-button type="button" (click)="closeDialog(false)">
            <div class="cancel-back-btn-content">
                <span><p class="cancel-back-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button   mat-flat-button [disabled]="((unitOfMeasurement === 'Hectares' ? gridSpacing < 0.1 : gridSpacing < 10) && !data?.editPoint) || isRotationInvalid"
                class="apply-filtering-btn" (click)="closeDialog(true)">
            <div class="apply-filtering-content">
                <span><p class="apply-filtering-text">Apply</p></span>
            </div>
        </button>
    </div>
</div>
